import { BusinessUnitKey, type BusinessUnitConfig } from '@/modules/bu/bu.types';

// This product's entry in the BU registry, which discovers it by filename.
// Nothing outside this folder lists Cleepo: deleting the folder removes the
// product from the app.
export const config: BusinessUnitConfig = {
  key: BusinessUnitKey.Cleepo,
  order: 2,
  label: 'Cleepo',
  basePath: '/cleepo',
  domain: import.meta.env.VITE_APP_CLEEPO_URL,
  dashboardRouteName: 'CleepoDashboardView',
  loginRouteName: 'CleepoAuthLoginView',
  selectAccountRouteName: 'CleepoSelectAccountView',
  investRouteName: 'CleepoInvestView',
  websiteUrl: 'https://cleepo.ai',
  supportWebsiteUrl: 'https://engeni.com',
  supportEmail: 'info@engeni.com',
  supportPhones: [
    { region: 'Argentina', telHref: 'tel:+54 11 51288641', label: '+54 11 51288641' },
    { region: 'México y LATAM', telHref: 'tel:+52 55 9435 6064', label: '+52 55 9435 6064' },
    { region: 'USA', telHref: 'tel:+1 786 6000612', label: '+1 786 600 0612' },
  ],
  privacyPolicyUrl: 'https://engeni.com/privacy.html',
  supportWhatsappUrl:
    'https://api.whatsapp.com/send?phone=5491152633802&text=Hola!+Estoy+en+mi+Panel+de+Control+y+necesito+ayuda+con+algo+%F0%9F%99%8B',
  supportWhatsappLabel: '+54 11 5263 3802',
  supportWhatsappByCountry: {
    MX: { phone: '5215594356064', label: '+52 1 55 9435 6064' },
  },
  hasPlanSubscriptionApproval: false,
  chooserDescriptionKey: 'common.choose_business_unit_cleepo_description',
  cartSelectI18nPrefix: 'cleepo.cart_select',
  orbitEntityType: 'project',
  orbitPathTemplate: '/cleepo/project/:id/info',
  logoPath: '/images/cleepo-logo-green-blue.png',
  faviconPath: '/favicon/favicon-cleepo.ico',
};
